import Splide from '@splidejs/splide';

/**
 * This class represents Splide gallery on the page.
 * Slider Gallery means, that it will just allow sliding
 */
export default class SliderGallery {

    /**
    * Initialize gallery.
    *
    * @param {String} galleryName
    * @param {Boolean} fromMap defines if the constructor is called from map - if yes the height is different
    */
    constructor(galleryName, fromMap = false)
    {
        this.gallery = $('[data-slider-gallery="' + galleryName + '"]');
        this.gallerySlider = this.gallery.find('[data-gallery-slider]');
        this.mapHeight = 175;
        this.masonryHeight = 253;

        this.height = fromMap ? this.mapHeight : this.masonryHeight;

        this.slider = undefined;
        this.sliderOptions = {
            lazyLoad: 'nearby',
            type: 'loop',
            waitForTransition: true,
            height: this.height,
            keyboard: true,
            slideFocus: true
        };
    }

    /**
     * Function that inits the gallery
     */
    initGallery()
    {
        if (this.slider === undefined && this.gallery.find('img').length > 0) {
            this.slider = new Splide('#' + this.gallerySlider.attr('id'), this.sliderOptions).mount();
        }
    }
}
